import { Checkbox, FormControl, FormControlLabel, InputLabel, makeStyles, MenuItem, Paper, Select, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import data from '../../json/tabelle.json';
import { ADD_COM_IRPEF_PercDataClass, DefaultInputProps } from '../../types/types';
import { regioni } from "../../utils/costanti";
import { API_elaboraIForfetari } from '../../utils/functions';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             //minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         },
//         select: {
//             width: "10rem",
//         },
//     }),
// );

export default function DatiCollaboratore1(props: DefaultInputProps) {
    const [global] = useGlobal<IGlobalState>();
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeDatiCollaboratore1";
    const { state } = props;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    };

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraIForfetari(props, global, name, value, action, true);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    };

    const handleBlur = (e: any) => {
        // API_elaboraIForfetari(props, global);
    }

    const ADD_COM_IRPEF = data.ADD_COM_IRPEF as ADD_COM_IRPEF_PercDataClass;

    let error = state.datiCollaboratore1.nomeCognome1 === undefined || state.datiCollaboratore1.nomeCognome1 === "";
    return (
        <React.Fragment>
            {state.quotaCollab1 !== undefined && state.quotaCollab1 > 0 ?
                (<Paper className={gClasses.mainPaper}>
                    <SectionTitle text="Dati collaboratore 1"></SectionTitle>
                    <TextField
                        required
                        error={error}
                        helperText={error ? "Campo obbligatorio" : ""}
                        id="nomeCognome1"
                        name="nomeCognome1"
                        label="Nome collaboratore"
                        value={state.datiCollaboratore1.nomeCognome1}
                        onChange={handleChange} onBlur={handleBlur}
                        className={gClasses.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                    />
                    <div>
                        <SectionSubTitle text="Redditi diversi da impresa/lav. Autonomo"></SectionSubTitle>
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E111"
                            label="Pensione"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E111}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E112"
                            label="Lav. dipendente e assim."
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E112}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            tooltip="Redditi di lavoro dipendente e assimilati per i quali spetta la detrazione d'imposta per redditi di lavoro dipendente."
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E113"
                            label="Assimilati lav. dipendente"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E113}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            tooltip="Redditi di lavoro dipendente e assimilati per i quali spetta la detrazione d'imposta per redditi di lavoro dipendente."
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E114"
                            label="Diversi lettere i) e l)"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E114}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E115"
                            label="Fabbricati locati"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E115}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            tooltip="Redditi dei fabbricati locati diversi da quelli da assoggettare a cedolare secca."
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E116"
                            label="Altri"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E116}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            tooltip="Redditi di capitale, redditi diversi escluse lettere i) e l) e redditi dei terreni affittati o esenti da IMU."
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E117"
                            label="Abitazione principale"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E117}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                        <NumberField
                            name="redditiDiversiDallaPartecipazione_E119"
                            label="Redditi a cedolare secca"
                            value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E119}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />

                        <SectionSubTitle text="Altri dati personali"></SectionSubTitle>
                        <Typography variant="h6">Familiari a Carico</Typography>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiCollaboratore1.altriDatiPersonali_H112}
                                    name='altriDatiPersonali_H112'
                                    id='altriDatiPersonali_H112'
                                    value={state.datiCollaboratore1.altriDatiPersonali_H112}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Coniuge"
                        />
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="altriDatiPersonali_I99">Figli n.</InputLabel>
                            <Select
                                className={gClasses.selectIForf}
                                value={state.datiCollaboratore1.altriDatiPersonali_J112}
                                inputProps={{ name: 'altriDatiPersonali_J112', id: 'altriDatiPersonali_J112' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="altriDatiPersonali_L112">%</InputLabel>
                            <Select
                                className={gClasses.selectIForf}
                                value={state.datiCollaboratore1.altriDatiPersonali_L112}
                                inputProps={{ name: 'altriDatiPersonali_L112', id: 'altriDatiPersonali_L112' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={50}>50%</MenuItem>
                                <MenuItem value={100}>100%</MenuItem>
                            </Select>
                        </FormControl>
                        <div>
                            <NumberField
                                name="altriDatiPersonali_L114"
                                label="Oneri deducibili"
                                value={state.datiCollaboratore1.altriDatiPersonali_L114}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                                helperText="(diversi dai contributi)"
                            />
                            <NumberField
                                name="altriDatiPersonali_L115"
                                label="Detrazioni per oneri"
                                value={state.datiCollaboratore1.altriDatiPersonali_L115}
                                className={gClasses.textField}
                                onChange={handleChange} onBlur={handleBlur}
                                helperText="ed altre detrazioni e crediti"
                            />
                        </div>
                        <div>
                            <FormControl className={gClasses.formControl}>
                                <InputLabel htmlFor="altriDatiPersonali_I117">Regione di residenza</InputLabel>
                                <Select
                                    className={gClasses.selectIForf}
                                    value={state.datiCollaboratore1.altriDatiPersonali_I117}
                                    inputProps={{ name: 'altriDatiPersonali_I117', id: 'altriDatiPersonali_I117' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={0}>Non definito</MenuItem>
                                    {regioni.map(regione => (
                                        <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl className={gClasses.formControl}>
                                <InputLabel htmlFor="altriDatiPersonali_M117">Add. Com. Irpef</InputLabel>
                                <Select
                                    className={gClasses.selectIForf}
                                    value={state.datiCollaboratore1.altriDatiPersonali_M117}
                                    inputProps={{ name: 'altriDatiPersonali_M117', id: 'altriDatiPersonali_M117' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                                    <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                                </Select>
                            </FormControl>
                            {/* <CustomSymbolField className="" id="quotaReddito" name="quotaReddito" label="Quota Reddito" value={0} symbol="%" readOnly={true}></CustomSymbolField> */}
                        </div>
                        <div>
                            <NumberField
                                name="quotaReddito"
                                label="Quota reddito analitico"
                                value={state.datiCollaboratore1.altriDatiPersonali_J118}
                                className={gClasses.textFieldReadOnly}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </Paper>) : <p></p>}
        </React.Fragment>
    );
}